import { FiArrowLeftCircle } from "react-icons/fi";
import styled, { css } from "styled-components";

export const SingleTopicPageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding-top: 2rem;

  .centralize-div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    width: 50%;

    @media (max-width: 1050px) {
      width: 100%;
      padding: 1rem;
    }
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      button {
        svg,
        p {
          color: #ffffff;
        }
      }
    `}

  .author-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4rem;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column !important;

    .author-content {
      margin-top: 0;
      width: 100%;
    }
  }

  @media (max-width: 500px) {
    .centralize-div {
      width: 100vw;
      padding: 0;
    }
  }
`;

export const TopicHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  span,
  svg {
    color: ${({ theme }) =>
      theme.mode === "dark" ? "#fff" : "#585858"} !important;
  }

  > button {
    border: 0;
    appearance: none;
    padding-left: 0;
    transition: all 0.6s;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent !important;
    background: transparent !important;
    box-shadow: none !important;

    font-size: 20px;

    color: ${({ theme }) =>
      theme.mode === "dark" ? "#fff" : "#404040"} !important;

    svg {
      height: 23px;
      width: 23px;
    }

    &:hover {
      transition: all 0.6s;
      transform: translateX(-10px);
      background-color: transparent;
      appearance: none;
    }
  }

  @media (max-width: 500px) {
    background-color: ${({ theme }) => theme.colors.modalBackgroundColor};
    margin-top: -20px;
    padding: 20px 16px 12px 16px;
  }
`;

export const IconFiArrowLeftCircle = styled(FiArrowLeftCircle)`
  margin-right: 8px;
  font-size: 23px;
`;

export const GoBack = styled.div`
  font-size: 18px;

  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;
